import '@fontsource/inconsolata';
import '@fontsource/montserrat/variable.css';
import ReactDOM from 'react-dom/client';
import './utils/sentry/sentry';

import { ChakraProvider } from '@chakra-ui/react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import { configureApiClient, configureCognitoClient } from '@aslanpay/portal-common-lib';

import apiConfig from 'app/constants/api';
import authConfig from 'app/constants/aws';

import { AuthContextProvider } from 'app/contexts/Auth';

import theme from 'app/styles/theme';

import { HelmetProvider } from 'react-helmet-async';

import Routes from './routes';

configureApiClient(apiConfig);
configureCognitoClient(authConfig);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <HelmetProvider>
    <ChakraProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <AuthContextProvider>
          <Routes />
        </AuthContextProvider>
      </QueryClientProvider>
    </ChakraProvider>
  </HelmetProvider>
);
